import Select from "react-select";
import { compactSelectStyles } from "../../../utils/reactSelectControlStyles.js";
import styles from "../../../styles/Reports.module.css";
import ReportFilterSection from "./ReportFilterSection.jsx";
import ReportYearSelect from "./ReportYearSelect.jsx";

const YearB2bEventPanel = ({
  t,
  reportI18nKeys,
  yearOptions,
  selectedYear,
  selectedReportOption,
  b2bEventsOptions,
  selectedB2bEvent,
  loadingB2bEvents,
  b2bEventSelectProps,
  handlers,
}) => {
  const { onYearOptionChange, onSelectEvent } = handlers;

  return (
  <ReportFilterSection t={t} reportI18nKeys={reportI18nKeys}>
    <ReportYearSelect
      t={t}
      reportI18nKeys={reportI18nKeys}
      yearOptions={yearOptions}
      selectedYear={selectedYear}
      onYearOptionChange={onYearOptionChange}
      isDisabled={!selectedReportOption}
    />
    <div className={styles.filterItemContent}>
      <label className={styles.label}>{t(reportI18nKeys.EVENT)}</label>
      <Select
        options={b2bEventsOptions}
        value={selectedB2bEvent}
        onChange={onSelectEvent}
        isClearable
        isDisabled={!selectedYear}
        isLoading={loadingB2bEvents}
        placeholder={t(reportI18nKeys.EVENT_PLACEHOLDER)}
        styles={compactSelectStyles}
        {...b2bEventSelectProps}
      />
    </div>
  </ReportFilterSection>
  );
};

export default YearB2bEventPanel;
